import { FC, useCallback } from 'react';
import { FILTER_KEY, FILTER_NAME, FILTER_NAME_REDESIGN } from './constants';
import { useModalState, useShowSearchMetaTooltip } from 'shared/hooks';
import { SearchResultsTooltip } from 'shared/components/SearchResultsTooltip';
import { AdvancedFiltersModalContainer } from './containers';
import { AdvancedFiltersButton } from 'shared/components/AdvancedFiltersButton';
import { AdvancedFiltersButtonV2 } from 'shared/components/AdvancedFiltersButtonV2';
import { useSelector } from 'react-redux';
import { selectIsSomeAdvancedFiltersSelected } from 'shared/selectors/advancedFilters';
import { trackShowAdvancedFiltersClick } from './tracking';
import { selectIsInlineFiltersRedesigned } from 'shared/selectors/redesigned/selectIsInlineFiltersRedesigned';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { EPageType } from 'shared/types/page';
import { trackQuickFilterClick } from 'shared/utils/analytics';

export const AdvancedFiltersContainer: FC = () => {
  const { opened, onOpen, onClose } = useModalState();

  const handleOpen = useCallback(() => {
    onOpen();
    trackQuickFilterClick('main');
    trackShowAdvancedFiltersClick();
  }, [onOpen]);

  const showSearchMetaTooltip = useShowSearchMetaTooltip(FILTER_KEY);

  const isSomeAdvancedFiltersSelected = useSelector(selectIsSomeAdvancedFiltersSelected);

  const isFiltersRedesignEnabled = useSelector(selectIsInlineFiltersRedesigned);

  const isMainPage = useSelector(selectPageType) === EPageType.MAIN;

  return (
    <>
      <SearchResultsTooltip open={showSearchMetaTooltip} placement="bottom-start">
        {isFiltersRedesignEnabled ? (
          <AdvancedFiltersButtonV2 onClick={handleOpen} showBadge={!opened && isSomeAdvancedFiltersSelected}>
            {isMainPage ? '' : FILTER_NAME_REDESIGN}
          </AdvancedFiltersButtonV2>
        ) : (
          <AdvancedFiltersButton onClick={handleOpen} showBadge={!opened && isSomeAdvancedFiltersSelected}>
            {FILTER_NAME}
          </AdvancedFiltersButton>
        )}
      </SearchResultsTooltip>
      {opened && <AdvancedFiltersModalContainer isRedesignEnabled={isFiltersRedesignEnabled} onClose={onClose} />}
    </>
  );
};
